let insectData = [
  {
    key: 1991,
    img: "insects/NH-Icon-commonbutterfly.png",
    name: "Common Butterfly",
    price: 160,
  },
  {
    key: 1992,
    img: "insects/NH-Icon-yellowbutterfly.png",
    name: "Yellow Butterfly",
    price: 160,
  },
  {
    key: 1993,
    img: "insects/NH-Icon-tigerbutterfly.png",
    name: "Tiger Butterfly",
    price: 240,
  },
  {
    key: 1994,
    img: "insects/NH-Icon-peacockbutterfly.png",
    name: "Peacock Butterfly",
    price: 2500,
  },
  {
    key: 1995,
    img: "insects/NH-Icon-commonbluebottle.png",
    name: "Common Bluebottle",
    price: 300,
  },
  {
    key: 1996,
    img: "insects/NH-Icon-paperkitebutterfly.png",
    name: "Paper Kite Butterfly",
    price: 1000,
  },
  {
    key: 1997,
    img: "insects/NH-Icon-greatpurpleemperor.png",
    name: "Great Purple Emperor",
    price: 3000,
  },
  {
    key: 1998,
    img: "insects/NH-Icon-monarchbutterfly.png",
    name: "Monarch Butterfly",
    price: 140,
  },
  {
    key: 1999,
    img: "insects/NH-Icon-emperorbutterfly.png",
    name: "Emperor Butterfly",
    price: 4000,
  },
  {
    key: 19910,
    img: "insects/NH-Icon-agriasbutterfly.png",
    name: "Agrias Butterfly",
    price: 3000,
  },
  {
    key: 19911,
    img: "insects/NH-Icon-rajahbrookesbirdwing.png",
    name: "Rajah Brookes Birdwing",
    price: 2500,
  },
  {
    key: 19912,
    img: "insects/NH-Icon-queenalexandrasbirdwing.png",
    name: "Queen Alexandras Birdwing",
    price: 4000,
  },
  { key: 19913, img: "insects/NH-Icon-moth.png", name: "Moth", price: 130 },
  {
    key: 19914,
    img: "insects/NH-Icon-atlasmoth.png",
    name: "Atlas Moth",
    price: 3000,
  },
  {
    key: 19915,
    img: "insects/NH-Icon-madagascansunsetmoth.png",
    name: "Madagascan Sunset Moth",
    price: 2500,
  },
  {
    key: 19916,
    img: "insects/NH-Icon-longlocust.png",
    name: "Long Locust",
    price: 200,
  },
  {
    key: 19917,
    img: "insects/NH-Icon-migratorylocust.png",
    name: "Migratorty Locust",
    price: 600,
  },
  {
    key: 19918,
    img: "insects/NH-Icon-ricegrasshopper.png",
    name: "Rice Grasshopper",
    price: 160,
  },
  {
    key: 19919,
    img: "insects/NH-Icon-grasshopper.png",
    name: "Grass Hopper",
    price: 160,
  },
  { key: 19920, img: "insects/NH-Icon-cricket.png", name: "Cricket", price: 130 },
  {
    key: 19921,
    img: "insects/NH-Icon-bellcricket.png",
    name: "Bell Cricket",
    price: 130,
  },
  { key: 19922, img: "insects/NH-Icon-mantis.png", name: "Mantis", price: 430 },
  {
    key: 19923,
    img: "insects/NH-Icon-orchidmantis.png",
    name: "Orchid Mantis",
    price: 2400,
  },
  {
    key: 19924,
    img: "insects/NH-Icon-honeybee.png",
    name: "Honey Bee",
    price: 200,
  },
  { key: 19925, img: "insects/NH-Icon-wasp.png", name: "Wasp", price: 2500 },
  {
    key: 19926,
    img: "insects/NH-Icon-browncicada.png",
    name: "Brown Cicado",
    price: 250,
  },
  {
    key: 19927,
    img: "insects/NH-Icon-robustcicada.png",
    name: "Robust Cicada",
    price: 300,
  },
  {
    key: 19928,
    img: "insects/NH-Icon-giantcicada.png",
    name: "Giant Cicada",
    price: 500,
  },
  {
    key: 19929,
    img: "insects/NH-Icon-walkercicada.png",
    name: "Walker Cicada",
    price: 400,
  },
  {
    key: 19930,
    img: "insects/NH-Icon-eveningcicada.png",
    name: "Evening Cicada",
    price: 550,
  },
  {
    key: 19931,
    img: "insects/NH-Icon-cicadashell.png",
    name: "Cicada Shell",
    price: 10,
  },
  {
    key: 19932,
    img: "insects/NH-Icon-reddragonfly.png",
    name: "Red Dragonfly",
    price: 180,
  },
  {
    key: 19933,
    img: "insects/NH-Icon-darnerdragonfly.png",
    name: "Darner Dragonfly",
    price: 230,
  },
  {
    key: 19934,
    img: "insects/NH-Icon-bandeddragonfly.png",
    name: "Banded Dragonfly",
    price: 4500,
  },
  {
    key: 19935,
    img: "insects/NH-Icon-damselfly.png",
    name: "Damselfly",
    price: 500,
  },
  { key: 19936, img: "insects/NH-Icon-firefly.png", name: "Firefly", price: 300 },
  {
    key: 19937,
    img: "insects/NH-Icon-molecricket.png",
    name: "Mole Cricket",
    price: 500,
  },
  {
    key: 19938,
    img: "insects/NH-Icon-pondskater.png",
    name: "Pond Skater",
    price: 130,
  },
  {
    key: 19939,
    img: "insects/NH-Icon-divingbeetle.png",
    name: "Diving Beetle",
    price: 800,
  },
  {
    key: 19940,
    img: "insects/NH-Icon-giantwaterbug.png",
    name: "Giant Water Bug",
    price: 2000,
  },
  {
    key: 19941,
    img: "insects/NH-Icon-stinkbug.png",
    name: "Stinkbug",
    price: 120,
  },
  {
    key: 19942,
    img: "insects/NH-Icon-manfacedstinkbug.png",
    name: "Man-Faced Stink Bug",
    price: 1000,
  },
  { key: 19943, img: "insects/NH-Icon-ladybug.png", name: "Ladybug", price: 200 },
  {
    key: 19944,
    img: "insects/NH-Icon-tigerbeetle.png",
    name: "Tiger Beetle",
    price: 1500,
  },
  {
    key: 19945,
    img: "insects/NH-Icon-jewelbeetle.png",
    name: "Jewel Beetle",
    price: 2400,
  },
  {
    key: 19946,
    img: "insects/NH-Icon-violinbeetle.png",
    name: "Violin Beetle",
    price: 450,
  },
  {
    key: 19947,
    img: "insects/NH-Icon-citruslonghornedbeetle.png",
    name: "Citrus Long-Horned Beetle",
    price: 350,
  },
  {
    key: 19948,
    img: "insects/NH-Icon-rosaliabatesibeetle.png",
    name: "Rosalia Batesi Beetle",
    price: 3000,
  },
  {
    key: 19949,
    img: "insects/NH-Icon-blueweevilbeetle.png",
    name: "Blue Weevil Beetle",
    price: 800,
  },
  {
    key: 19950,
    img: "insects/NH-Icon-dungbeetle.png",
    name: "Dung Beetle",
    price: 3000,
  },
  {
    key: 19951,
    img: "insects/NH-Icon-earthboringdungbeetle.png",
    name: "Earth Boring Dung Beetle",
    price: 300,
  },
  {
    key: 19952,
    img: "insects/NH-Icon-scarabbeetle.png",
    name: "Scarab Beetle",
    price: 10000,
  },
  {
    key: 19953,
    img: "insects/NH-Icon-dronebeetle.png",
    name: "Drone Beetle",
    price: 200,
  },
  {
    key: 19954,
    img: "insects/NH-Icon-goliathbeetle.png",
    name: "Goliath Beetle",
    price: 8000,
  },
  {
    key: 19955,
    img: "insects/NH-Icon-sawstag.png",
    name: "Saw Stag",
    price: 2000,
  },
  {
    key: 19956,
    img: "insects/NH-Icon-miyamastag.png",
    name: "Miyama Stag",
    price: 1000,
  },
  {
    key: 19957,
    img: "insects/NH-Icon-giantstag.png",
    name: "Giant Stag",
    price: 10000,
  },
  {
    key: 19958,
    img: "insects/NH-Icon-rainbowstag.png",
    name: "Rainbow Stag",
    price: 6000,
  },
  {
    key: 19959,
    img: "insects/NH-Icon-cyclommatusstag.png",
    name: "Cyclommatus Stag",
    price: 8000,
  },
  {
    key: 19960,
    img: "insects/NH-Icon-goldenstag.png",
    name: "Golden Stag",
    price: 12000,
  },
  {
    key: 19961,
    img: "insects/NH-Icon-giraffestag.png",
    name: "Giraffe Stag",
    price: 12000,
  },
  {
    key: 19962,
    img: "insects/NH-Icon-horneddynastid.png",
    name: "Horned Dynastid",
    price: 1350,
  },
  {
    key: 19963,
    img: "insects/NH-Icon-hornedatlas.png",
    name: "Horned Atlas",
    price: 8000,
  },
  {
    key: 19964,
    img: "insects/NH-Icon-hornedelephant.png",
    name: "Horned Elephant",
    price: 8000,
  },
  {
    key: 19965,
    img: "insects/NH-Icon-hornedhercules.png",
    name: "Horned Hercules",
    price: 12000,
  },
  {
    key: 19966,
    img: "insects/NH-Icon-walkingstick.png",
    name: "Walking Stick",
    price: 600,
  },
  {
    key: 19967,
    img: "insects/NH-Icon-walkingleaf.png",
    name: "Walking Leaf",
    price: 600,
  },
  { key: 19968, img: "insects/NH-Icon-bagworm.png", name: "Bagworm", price: 600 },
  { key: 19969, img: "insects/NH-Icon-ant.png", name: "Ant", price: 80 },
  {
    key: 19970,
    img: "insects/NH-Icon-hermitcrab.png",
    name: "Hermit Crab",
    price: 1000,
  },
  {
    key: 19971,
    img: "insects/NH-Icon-wharfroach.png",
    name: "Wharf Roach",
    price: 200,
  },
  { key: 19972, img: "insects/NH-Icon-fly.png", name: "Fly", price: 60 },
  {
    key: 19973,
    img: "insects/NH-Icon-mosquito.png",
    name: "Mosquito",
    price: 130,
  },
  { key: 19974, img: "insects/NH-Icon-flea.png", name: "Flea", price: 70 },
  { key: 19975, img: "insects/NH-Icon-snail.png", name: "Snail", price: 250 },
  { key: 19976, img: "insects/NH-Icon-pillbug.png", name: "Pill Bug", price: 250 },
  {
    key: 19977,
    img: "insects/NH-Icon-centipede.png",
    name: "Centipede",
    price: 300,
  },
  { key: 19978, img: "insects/NH-Icon-spider.png", name: "Spider", price: 600 },
  {
    key: 19979,
    img: "insects/NH-Icon-tarantula.png",
    name: "Tarantula",
    price: 8000,
  },
  {
    key: 19980,
    img: "insects/NH-Icon-scorpion.png",
    name: "Scorpion",
    price: 8000,
  },
];

export default insectData;
